import Logger from '../../../services/Logger';
import localization from '../../../shared/strings';
import Toast from '../../../components/Toast';
import TYPES from '../../action-types';
import { reloadCurrentPage } from '../../../helpers/history';
import * as utils from '../../../shared/utils';

/**
 * Updates default asset-level alt text (`asset.altText`).
 */
const setAltText = (assetId, altText) => async (dispatch, getState, { sdk }) => {
  try {
    await sdk.assets.setAltText(assetId, altText);

    dispatch({
      type: TYPES.ASSETS.SET_ALT_TEXT.COMPLETE,
      payload: { assetId, altText: altText ?? '' },
    });
  } catch (error) {
    const errorStatus = utils.getStatusFromResponceError(error);
    const errorMessage = errorStatus === 403
      ? localization.NO_PERMISSION_TO_ACCESS
      : localization.DETAILS.textCantUpdate('alt text');
    Toast(errorMessage, {
      autoClose: false,
      type: 'error',
      onOk: reloadCurrentPage,
      btnOkValue: localization.HISTORY.textBtnRefresh,
    });
    dispatch({ type: TYPES.ASSETS.SET_ALT_TEXT.FAILED, error });
    Logger.error(new Error('Error change alt text'), { error, assetId }, [
      'SetAltTextFailed',
      { assetId: String(assetId) },
    ]);
  }
};

export default setAltText;
